import React, { RefObject } from "react";

export const refs = {
  homeRef: {} as RefObject<HTMLDivElement>,
  aboutRef: {} as RefObject<HTMLDivElement>,
  experienceRef: {} as RefObject<HTMLDivElement>,
  projectRef: {} as RefObject<HTMLDivElement>,
  contactRef: {} as RefObject<HTMLDivElement>,
  currentPageY: 0,
};

export const ReferenceContext = React.createContext(refs);
